import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react';
import { useSelect } from '../hooks/useCoreContext';
import { AnimatePresence, motion } from 'framer-motion';
import clsx from 'clsx';

const Positioner = ({ children, className }: { children: React.ReactNode; className?: string }) => {
	const {
		open,
		getFloatingProps,
		refs,
		floatingStyles,
		context,
		highlightedIndex,
		ids,
		creatable,
		onEnter,
	} = useSelect();

	return (
		<>
			<FloatingPortal>
				<AnimatePresence>
					{open && (
						<FloatingFocusManager
							context={context}
							modal={false}
							initialFocus={creatable ? -1 : 0}
							returnFocus={false}
							guards={false}
						>
							<div
								ref={refs.setFloating}
								style={floatingStyles}
								aria-activedescendant={
									highlightedIndex >= 0 ? ids.option(highlightedIndex) : undefined
								}
								{...getFloatingProps({
									onKeyDown: (e: React.KeyboardEvent) => {
										onEnter(e);
									},
								})}
								className='z-[9999] scrollbar-hidden outline-none'
							>
								<motion.div
									initial={{ opacity: 0, scale: 0.95, y: 0 }}
									animate={{ opacity: 1, scale: 1, y: 0 }}
									exit={{ opacity: 0, scale: 0.95, y: -5 }}
									transition={{ duration: 0.18, ease: 'easeOut' }}
									className={clsx(
										`min-w-60 w-auto bg-light border border-tertiary rounded-lg shadow-xl z-[9999] p-0 ${className}`,
									)}
								>
									{children}
								</motion.div>
							</div>
						</FloatingFocusManager>
					)}
				</AnimatePresence>
			</FloatingPortal>
		</>
	);
};

export default Positioner;
